import React from "react";
import logoutIcon from "../../assets/logoutIcon.jpg";
import "../../style/logout.scss";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

const LogoutForm = ({ handleCancel, handleLogout }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="logout-confirmation-container">
        <div className="logout-icon-container">
          <img src={logoutIcon} alt="logout" />
        </div>
        <p className="logout-message">{t("areYouSureYouWantToLogout")}</p>
      </div>

      <div className="logout-confirmation-actions" key="footer-buttons">
        <Button key="cancel" type="primary" onClick={handleCancel}>
          {t("cancel")}
        </Button>
        <Button key="ok" className="logout-button" onClick={handleLogout}>
          {t("logout")}
        </Button>
      </div>
    </>
  );
};

export default LogoutForm;
